import { render } from "./workspace.vue?vue&type=template&id=2e2aaac4&scoped=true&lang=pug"
import script from "./workspace.vue?vue&type=script&setup=true&lang=js"
export * from "./workspace.vue?vue&type=script&setup=true&lang=js"

import "./workspace.vue?vue&type=style&index=0&id=2e2aaac4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2e2aaac4"

export default script